import { render, staticRenderFns } from "./langSwitcher.vue?vue&type=template&id=d96478b2&scoped=true&"
import script from "./langSwitcher.vue?vue&type=script&lang=js&"
export * from "./langSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./langSwitcher.vue?vue&type=style&index=0&id=d96478b2&lang=scss&scoped=true&"
import style1 from "./langSwitcher.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96478b2",
  null
  
)

export default component.exports